/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import Drawer from "@mui/material/Drawer";
import { ClickAwayListener } from "@mui/material";
import { NavLink } from "react-router-dom";
import t from "../../../theme";

const NotificationDrawer = ({
  showRightDrawer,
  drawerWidth,
  noticationdata,
  itemsToShow,
  onClose,
  onClickAway,
  onNavigate,
  onMarkSeen,
}) => {
  if (!showRightDrawer) return null;

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <Drawer
        anchor={"right"}
        variant="persistent"
        open={showRightDrawer}
        ModalProps={{
          onBackdropClick: onClose,
        }}
        css={[
          {
            width: drawerWidth,
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: "border-box",
              marginTop: 60,
              width: 330,
              height: 410,
              overflowX: "hidden",
              boxShadow: t.shadow.lg,
              backdropFilter: t.blur.heavy,
              background: t.glass.primary,
              borderRadius: "0 0 0 20px",
            },
          },
        ]}
        onClose={onClose}
      >
        <h5
          style={{
            marginLeft: "18px",
            marginTop: "20px",
            color: t.text.primary,
            fontWeight: 600,
          }}
        >
          Notifications
        </h5>
        {noticationdata?.slice(0, itemsToShow).map((items) => (
          <div
            key={items?.uuid}
            className="container"
            style={{
              cursor: "pointer",
              marginBottom: 0,
              padding: "10px 0",
              borderRadius: "30px",
              width: "97%",
              margin: "5px",
              boxShadow: items?.is_seen
                ? `0 0 2px ${t.border.colorLight} inset`
                : `0 0 5px ${t.border.colorBase} inset`,
              border: `solid 1px ${t.border.colorLight}`,
              backgroundColor: items?.is_seen ? t.glass.light : t.glass.primary,
            }}
            onClick={() => {
              onClose();
              onNavigate(items.link);
              onMarkSeen(items?.uuid);
            }}
          >
            <p
              style={{
                marginLeft: "20px",
                width: "200px",
                fontSize: "0.8rem",
                color: items?.is_seen ? t.text.secondary : t.brand.black,
                marginBottom: 0,
              }}
            >
              {items.message}
            </p>
          </div>
        ))}
        <NavLink
          to="/Notifications"
          style={{
            color: t.text.link,
            textAlign: "end",
            marginRight: 18,
            marginBottom: 20,
          }}
        >
          <span style={{ fontSize: "0.8rem" }}>View More</span>
        </NavLink>
      </Drawer>
    </ClickAwayListener>
  );
};

NotificationDrawer.propTypes = {
  showRightDrawer: PropTypes.bool.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  noticationdata: PropTypes.array,
  itemsToShow: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickAway: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onMarkSeen: PropTypes.func.isRequired,
};

export default NotificationDrawer;
